import { Component, EventEmitter, h, State, Event } from '@stencil/core';
import store from '../../../helpers/store';
import { FlowStatus } from '../../../models/FlowStatus';
import { FlowSteps } from '../../../models/FlowSteps';
import { BaseComponent } from '../../base-component';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoPhone from '../../../assets/landing/ico-phone.svg';
import icoPhoneErr from '../../../assets/landing/ico-phone-err.svg';

@Component({
  tag: 'sms-code-validation',
  styleUrl: 'sms-code-validation.css',
})
export class SmsCodeValidation {
  @State() private title: string;
  @State() private details: string;
  @State() private buttonText: string;
  @State() private code: string;
  @State() private canSend: boolean = false;
  @State() private sending: boolean = false;
  @State() private hasError: boolean = false;

  private translations: TranslationValues;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  constructor() {}

  private async doAction() {
    if (this.sending) return;
    this.sending = true;
    this.canSend = false;

    try {
      var codeChecked = await ApiCall.instance.CheckOTPCode(store.requestId, this.code);
      store.flowStatus = FlowStatus[codeChecked.state];

      if (store.flowStatus == FlowStatus.CODEERROR) this.hasError = true;
      this.sending = false;
      this.code = '';
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  async disconnectedCallback() {
    await BaseComponent.finalize(FlowSteps.OtpCheck);
  }

  async componentWillLoad() {
    if (store.flowStatus == FlowStatus.CODEERROR) this.hasError = true;
  }

  async componentWillRender() {
    this.translations = await Translations.getValues();
    this.title = this.translations.CodeValidationValues.Title;
    this.details = this.translations.CodeValidationValues.Description;
    this.buttonText = this.translations.CodeValidationValues.Button;
  }

  async componentDidLoad() {
    await BaseComponent.initialize(FlowSteps.OtpCheck);
  }

  handleChangeCode(ev) {
    let value = ev.target ? ev.target.value : '';
    this.code = value;
    if (this.code.length > 4) this.code = this.code.substring(0, 4);
    this.canSend = this.code.length == 4;
    ev.target.value = this.code;

    this.hasError = false;
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-1 w-100">
          {this.hasError ? (
            <div>
              <div class="mb-1 ml-1 text-center">
                <img src={icoPhoneErr} style={{ width: '60px' }}></img>
              </div>
              <h1 class="text-center color-red px-1 mb-2">{this.translations.CodeValidationValues.Error}</h1>
            </div>
          ) : (
            <div>
              <div class="mb-1 ml-1 text-center">
                <img src={icoPhone} style={{ width: '60px' }}></img>
              </div>
              <h1 class="text-center px-1 mb-2">{this.title}</h1>
            </div>
          )}

          <p class="text-center mb-05">{this.details}</p>
          <div class="mb-2">
            <input placeholder="XXXX" type="tel" id="codeInput" class="main-input" onInput={ev => this.handleChangeCode(ev)} value={this.code} />
          </div>

          <div class="button flex mb-1 mx-3">
            {this.sending ? (
              <div class="img-loader rounded img-loader-button">
                <img class="loading-image loading-image-button" src={loaderImg}></img>
              </div>
            ) : null}
            <button id="action" disabled={!this.canSend} class="main-button" onClick={() => this.doAction()}>
              {this.buttonText}
            </button>
          </div>
          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
